<template>

  <div class="container">

    <b-row>
      <b-col md="12">
        <b-card title="Unbooked Search" class="margin-bottom" v-if="lookups">

          <b-form @submit="onSubmit" @reset="onReset" class="row">
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-group label="Company Name" label-for="companyName">
                <b-form-input id="companyName" v-model="form.companyName" type="text">
                </b-form-input>
              </b-form-group>

              <b-form-group label="Director" label-for="director">
                <b-form-select
                  id="director"
                  v-model="form.directorId"
                  :options="quantumaDirectors"
                  value-field="id"
                  text-field="fullName"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Conflict Check Complete" label-for="conflictCheckComplete">
                <b-form-select
                  id="conflictCheckComplete"
                  v-model="form.conflictCheckComplete"
                  :options="yesNo"
                  value-field="id"
                  text-field="title"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Engagement Letter Issued" label-for="engagementLetterIssued">
                <b-form-select
                  id="engagementLetterIssued"
                  v-model="form.engagementLetterIssued"
                  :options="yesNo"
                  value-field="id"
                  text-field="title"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Postcode" label-for="postcode">
                <b-form-input id="postcode" v-model="form.postcode" type="text">
                </b-form-input>
              </b-form-group>

              <b-form-group label="Email Address" label-for="emailAddress">
                <b-form-input id="emailAddress" v-model="form.emailAddress" type="text">
                </b-form-input>
              </b-form-group>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
              <b-form-group label="Vendor:" label-for="vendor">
                <b-form-input id="vendor" v-model="form.vendor" type="text">
                </b-form-input>
              </b-form-group>

              <b-form-group label="CurrentTeam" label-for="currentTeam">
                <b-form-select
                  id="currentTeam"
                  v-model="form.currentTeamId"
                  :options="teams"
                  value-field="value"
                  text-field="text"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="Tier:" label-for="tier">
                <b-form-select v-if="lookups"
                  id="tier"
                  v-model="form.tierId"
                  :options="companyTiers"
                  value-field="id"
                  text-field="name"
                ></b-form-select>
              </b-form-group>

              <b-form-group label="" label-for="callbacks">
                <b-form-radio v-model="form.includeCallbacks" name="include-callbacks" :value="true">Include Callbacks</b-form-radio>
                <b-form-radio v-model="form.includeCallbacks" name="include-callbacks" :value="false">Exclude Callbacks</b-form-radio>
                <b-form-radio v-model="form.includeCallbacks" name="include-callbacks" :value="null">Both</b-form-radio>
              </b-form-group>

              <FeedbackButton title="Search" icon="search" :busy="isBusy" :onClick="search" :disabled="!valid"/>

              <b-button type="reset" variant="info"
                ><font-awesome-icon icon="eraser" /> Clear</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <div class="row" v-if="!searchResults || searchResults.length == 0">
      <div class="col-sm-12 margin-top">
        <b-alert show><strong>No Search Results</strong></b-alert>
      </div>
    </div>

    <b-card :title="'Search Results (' + this.rows + ')'" class="margin-bottom"  v-if="searchResults && searchResults.length > 0">
      <!-- <div class="row">
        <div class="col-sm-12"><SubHeader :title="'Search Results (' + this.rows + ')'" /></div> -->

        <b-table
          striped
          hover
          :items="searchResults"
          :fields="fields"
          :current-page="form.pageNo"
          :per-page="0"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="form.sortDescending"
          no-local-sorting
          @sort-changed="sortingChanged"
        >
          <template v-slot:cell(company)="data">
            {{ data.item.companyName }}<br />
            <font-awesome-icon icon="envelope" /> {{ data.item.postcode }}<br />
            <font-awesome-icon icon="tag" /> {{ data.item.sectorName }}
          </template>

          <template v-slot:cell(contact)="data">
            <div>
              {{ data.item.primaryContact.fullname || `${data.item.primaryContact.primaryContactTitle}
              ${data.item.primaryContact.primaryContactFirstName}
              ${data.item.primaryContact.primaryContactLastName}`}}
            </div>
            <div v-bind:class="{ red: data.item.primaryContact.primaryContactTelephoneNumberCtps }">
              {{ data.item.primaryContact.primaryContactTelephoneNumber }}
            </div>
          </template>


          <template v-slot:cell(contacted)="data">
            <div>{{ getDate(data.item.lastContactDatetime) }}</div>
          </template>

          <template v-slot:cell(amended)="data">
            <div>{{ getDate(data.item.lastModifiedDatetime) }}</div>
          </template>


          <template v-slot:cell(callback)="data">
            <div>{{ getDate(data.item.callbackDatetime) }}</div>
            <div>{{ data.item.callbackUserFullName }} {{ getDate(data.item.callbackSetDatetime) }}</div>
          </template>

          <template v-slot:cell(status)="data">
            <div>{{ data.item.companyStatus }}</div>
            <div>{{ data.item.lockedUserFullName }}</div>
          </template>

          <template v-slot:cell(tier)="data">
            {{ data.item.tierId }}
          </template>

          <template v-slot:cell(nav)="data">

            <b-button
              :to="'/company/' + data.item.id"
              variant="warning"
              size="sm"
              type="button"
              block
            >
              <font-awesome-icon icon="edit" />&nbsp;Details
            </b-button>

            <!-- <router-link :to="'/company/' + data.item.companyId" tag="button" class="details btn btn-warning btn-xs"
              :disabled="!data.item.allowedCall">
              <font-awesome-icon icon="edit" /> Details
            </router-link>


            <b-button
              class="details btn btn-info"
              variant="info"
              :disabled="!data.item.allowedCall"
              size="sm"
              type="button"
              @click="transferCompany(data.item.companyId)"
            >
              <font-awesome-icon icon="exchange" /> Transfer
            </b-button> -->
          </template>
        </b-table>

        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="form.perPage"
          first-number
          last-number
        ></b-pagination>
      <!-- </div> -->
      <CompanyTransferCreateModal :companyId="selectedCompanyId" ref="companyTransferCreateModal"/>
    </b-card>
  </div>

</template>

<script>

import FeedbackButton from "@/components/shared/FeedbackButton.vue";
import CompanyTransferCreateModal from "@/components/shared/CompanyTransferCreateModal.vue";
import LookupsService from '@/services/Lookups.service'
import SearchService from '@/services/Search.service'
import { format } from 'date-fns'

export default {
  components: { CompanyTransferCreateModal, FeedbackButton },
  data() {
    return {
      form: {
        companyName: "",
        vendor: "",
        directorId: null,
        engagementLetterIssued: null,
        conflictCheckComplete: null,
        postcode: "",
        emailAddress: "",
        currentTeamId: null,
        companyNumber: "",
        telephoneNumber: "",
        tierId: null,
        includeCallbacks: null,
        pageNo: 1,
        pageSize: 10,
        sortColumn: "",
        sortDescending: false
      },
      teams: [
        {value: null, text: "" },
        {value: 1, text: "Small Liquidations" },
        {value: 2, text: "Large Insolvency" },
        {value: 3, text: "Forensic Team" },
        {value: 4, text: "Restructuring Team" }
      ],
      searchResults: [],
      allSearchResults: [],
      fields: [
        { key: "company", label: "Company Name", sortable: true },
        { key: "contact", label: "Primary Contact", sortable: true },
        { key: "amended", label: "Last Amended", sortable: true },
        { key: "contacted", label: "Last Contacted", sortable: true },
        { key: "callback", label: "Callback", sortable: true },
        { key: "status", label: "Status/Owner", sortable: true },
        { key: "tier", label: "Tier", sortable: true },
        { key: "nav", label: "", sortable: false },
      ],
      yesNo: [{ id: null, title: ""}, { id: 1, title: "Yes"}, { id: false, title: "No"}],
      currentPage: 1,
      rows: 0,
      isBusy: false,
      sortBy: "",
      selectedCompanyId: null,
      lookups: null,
      toggleAll: false,
      showNoResults: false
    };
  },
  created() {
    LookupsService.loadLookups().then(result => {
      this.lookups = result.data;
    })
  },
  watch: {
    currentPage: {
      handler: function () {
        this.form.pageNo = this.currentPage;

        this.search()
          .then((result) => {
            this.searchResults = result.searchResults;
            this.allSearchResults = result.allSearchResults;
            this.rows = result.totalResults;
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  },
  computed: {
    companyTiers() {
      if (!this.lookups) return [{id: null, name: ""}];
      return [{id: null, name: ""}, ...this.lookups.companyTiers];
    },
    quantumaDirectors() {
      if (!this.lookups) return [{id: null, name: ""}];
      return [{id: null, fullName: ""}, ...this.lookups.quantumaDirectors];
    },
    valid() {
      return this.form.companyName != "" ||
        this.form.vendor != "" ||
        this.form.directorId != null ||
        this.form.engagementLetterIssued != null ||
        this.form.conflictCheckComplete != null ||
        this.form.postcode != "" ||
        this.form.emailAddress != "" ||
        this.form.currentTeamId != null ||
        this.form.companyNumber != "" ||
        this.form.telephoneNumber != "" ||
        this.form.tierId != null;
    }
  },

  methods: {
    getDate(date) {
      if (date == null) return "";
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
    async search() {
      if (!this.validateForm())
        return {searchResults: [], allSearchResults: [], totalResults: 0}

      this.isBusy = true;

      SearchService.unbookedSearch(this.form).then(response => {
        console.log(response);
        this.isBusy = false;
        this.searchResults = response.data.searchResults;
        this.allSearchResults = response.data.allSearchResults;
        this.rows = response.data.totalResults;
        this.showNoResults = (response.data && response.data.searchResults.length == 0);
      }).catch(() => {
        this.isBusy = false;
      });
    },
    async sortingChanged(ctx) {

      console.log(ctx);

      switch (ctx.sortBy) {
        case "company":
          this.form.sortColumn = "CompanyName";
          break;
        case "contact":
          this.form.sortColumn = "PrimaryContactLastName";
          break;
        case "status":
          this.form.sortColumn = "Status";
          break;
        case "tier":
          this.form.sortColumn = "CompanyTier";
          break;
      }
      this.currentPage = 0;
      //this.form.sortDirection = ctx.sortDesc ? "ASC" : "DESC";

      this.search();
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.search();
    },
    validateForm() {

      if (
        this.form.companyName != "" ||
        this.form.vendor != "" ||
        this.form.directorId != null ||
        this.form.engagementLetterIssued != null ||
        this.form.conflictCheckComplete != null ||
        this.form.postcode != "" ||
        this.form.emailAddress != "" ||
        this.form.currentTeamId != null ||
        this.form.companyNumber != "" ||
        this.form.telephoneNumber != "" ||
        this.form.tierId != null
      )
        return true;

      return false;
    },
    onReset() {
       this.form = {
        companyName: "",
        vendor: "",
        companyNumber: "",
        telephoneNumber: "",
        postcode: "",
        emailAddress: "",
        status: null,
        tier: null,
        pageNo: 1,
        pageSize: 10,
        sortDirection: "",
        sortColumn: "",
      }
      this.currentPage = 1;
      this.searchResults = [];
      this.allSearchResults = [];
      this.rows = 0;
    },
    /*transferCompany(companyId) {
      this.selectedCompanyId = companyId;
      this.$refs.companyTransferCreateModal.showModal();
    }*/
  },
};
</script>

<style scoped>
button {
  margin-right: 5px;
}
table {
  font-size: 0.85em;
}
</style>
